module.exports = __webpack_public_path__ + "static/img/1324.bf16a0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1324.jpg
// module id = 37
// module chunks = 1